import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

interface Props extends MessageDescriptor {
  values?: Record<string, React.ReactNode>;
}

const FormatMessage = ({ values = {}, ...props }: Props) => (
  <FormattedMessage
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    values={{
      ...values,
      br: <br />,
    }}
  />
);

export default FormatMessage;
